import {
  Avatar,
  AvatarProps,
  Box,
  BoxProps,
  ButtonBase,
  IconButton,
  IconButtonProps,
  IconProps,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { FilterValueType, Operator } from "../../services/swagger";
import { allowedOperators } from "../molecules/FilterInput";
import { useEffect, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTranslation } from "react-i18next";

interface OperatorSelectorButtonProps {
  type: FilterValueType;
  boxProps?: BoxProps;
  iconButtonProps?: IconButtonProps;
  avatarProps?: AvatarProps;
  iconProps?: IconProps;
  size?: number;
  value: Operator;
  onChange: (operator: Operator) => void;
}

export default function OperatorSelectorButton(
  props: OperatorSelectorButtonProps
) {
  const { t } = useTranslation("OperatorSelector");
  const operatorSymbol: { [key in Operator]: string } = {
    eq: t("eq"),
    gt: t("gt"),
    lt: t("lt"),
    ne: t("ne"),
    gte: t("gte"),
    lte: t("lte"),
    regex: t("regex"),
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeOperator = (newOperator: Operator) => {
    props.onChange(newOperator);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box {...props.boxProps}>
      <Menu
        anchorEl={anchorEl}
        elevation={1}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: { mt: 1 },
          },
        }}
      >
        {allowedOperators[props.type].map((operator) => {
          return (
            <MenuItem
              key={operator}
              onClick={() => handleChangeOperator(operator)}
              disableRipple
            >
              {operatorSymbol[operator]}
            </MenuItem>
          );
        })}
      </Menu>
      <IconButton
        onClick={handleClick}
        sx={{ p: 0 }}
        {...props.iconButtonProps}
        disableRipple
      >
        <Stack direction="row" alignItems="center">
          <Typography
            fontSize={props.size}
            sx={{
              maxWidth: 100,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {operatorSymbol[props.value]}
          </Typography>
          <ArrowDropDownIcon color="disabled" />
        </Stack>
      </IconButton>
    </Box>
  );
}
